import { render, staticRenderFns } from "./AddMaterialsModal.vue?vue&type=template&id=75c1f3cd&scoped=true"
import script from "./AddMaterialsModal.vue?vue&type=script&lang=js"
export * from "./AddMaterialsModal.vue?vue&type=script&lang=js"
import "./AddMaterialsModal.vue?vue&type=style&index=0&id=75c1f3cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1f3cd",
  null
  
)

export default component.exports